import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { RegisterComponent } from './views/register/register.component';
import {LoginComponent} from "./components/login/login.component";
import {AuthGuard} from "./security/auth.guard";
import {ConfirmEmailComponent} from "./components/confirm-email/confirm-email.component";
// import {ForgotPasswordComponent} from "./components/forgot-password/forgot-password.component";
import {ChangePasswordComponent} from "./components/change-password/change-password.component";
import {FormListComponent} from "./components/forms/form-list/form-list.component";
import {ImportSproutComponent} from "./components/forms/import-sprout/import-sprout.component";
import {ProcessBuilderComponent} from "./components/forms/process-builder/process-builder.component";
import {FormGroupTestComponent} from "./deleteme/form-group-test/form-group-test.component";
import {HomeComponent} from "./components/home/home.component";

export const routes: Routes = [
  {
    path: 'dashboard',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '#/dashboard',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'confirm',
    component: ConfirmEmailComponent,
    data: {
      title: 'Confirm'
    }
  },
  // {
  //   path: 'forgot',
  //   component: ForgotPasswordComponent,
  //   data: {
  //     title: 'Forgot Password'
  //   }
  // },
  {
    path: 'dummy',
    component: FormGroupTestComponent,
    data: {
      title: 'Forgot Password'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'base',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'buttons',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      },
      {
        path: 'password',
        canActivate: [AuthGuard],
        component: ChangePasswordComponent
      },
      {
        path: 'design/forms',
        canActivate: [AuthGuard],
        component: FormListComponent
      },
      {
        path: '',
        canActivate: [AuthGuard],
        component: HomeComponent
      },
      {
        path: 'design/import',
        canActivate: [AuthGuard],
        component: ImportSproutComponent
      },
      {
        path: 'design/process/builder',
        canActivate: [AuthGuard],
        component: ProcessBuilderComponent
      },
      {
        path: 'charts',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'icons',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'notifications',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'theme',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      },
      {
        path: 'widgets',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      }
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
